import React, { useEffect, useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { ContabilidadLayout } from 'akasia-components/Contabilidad/common/ContabilidadLayout';
import { ContabilidadContext } from 'akasia-components/Contabilidad/common/ContabilidadContext';
import useToken from 'hooks/useToken';
import DatePicker from "react-datepicker";
import { Col, Row, Container, Spinner } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';

const ResumenMensualImpuestosContent = () => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const { selectedCompany, globalDateQuarter: dateQuarter, setGlobalDateQuarter: setDateQuarter } = useContext(ContabilidadContext);

    const [cargando, setCargando] = useState(false);
    const formatCurrency = (amount, isDeduction = false) => {
        const value = amount || 0;
        const isNegative = value < 0;
        const applyRed = isNegative || (isDeduction && value > 0);
        return (
            <span className={applyRed ? "text-danger" : ""}>
                {(value).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
            </span>
        );
    };


    const [facturasEmitidas, setFacturasEmitidas] = useState([]);
    const [egresoEmitidas, setEgresoEmitidas] = useState({});
    const [pagoEmitidas, setPagoEmititdas] = useState({});


    const [facturasRecibidas, setFacturasRecibidas] = useState([]);
    const [egresoRecibidas, setEgresoRecibidas] = useState({});
    const [pagoRecibidas, setPagoRecibidas] = useState({});
    const [informe, setInforme] = useState({});


    useEffect(() => {
        if (selectedCompany?.vRFC) {
            ObtenerDatosImpuestos();
        } else {
            setFacturasEmitidas([]);
            setFacturasRecibidas([]);
            setInforme({});
            setEgresoEmitidas({});
            setPagoEmititdas({});
            setEgresoRecibidas({});
            setPagoRecibidas({});
        }
    }, [selectedCompany?.vRFC, dateQuarter]);


    /**
     * Función para manejar el cambio de fecha
     */
    const handleDateChange = (date) => {
        setDateQuarter(date);
    };

// obtenerRfcReceptor eliminado a favor de ContabilidadContext

    /**
     * Obtiene los Datos de los Gastos
     */
    const ObtenerDatosImpuestos = async () => {
        console.log(dateQuarter)
        setCargando(true);

        var date_ = dateQuarter;

        var month = new Date(date_).getMonth() + 1;
        var year = new Date(date_).getFullYear();

        // Asegura que el mes tenga siempre 2 dígitos (ej. 02, 03, ..., 12)
        var formattedMonth = month < 10 ? '0' + month : '' + month;

        const data = {
            year: '' + year,
            month: formattedMonth,
            rfc: selectedCompany?.vRFC
        };

        console.log("fecha enviada", data);


        const response = await fetch("/api/Impuestos/ObtenerDatosImpuestos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("==== OBTENER DATOS FACTURAS ====");

            const data = await response.json();

            if (data.iResponseType == 1) {


                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ImpuestosDATA", ObjDetalles);


                setFacturasEmitidas(ObjDetalles.table2);
                setEgresoEmitidas(ObjDetalles.table3[0]);
                setPagoEmititdas(ObjDetalles.table4[0]);


                setFacturasRecibidas(ObjDetalles.table5);
                setEgresoRecibidas(ObjDetalles.table6[0]);
                setPagoRecibidas(ObjDetalles.table7[0]);

                setInforme({
                    ...ObjDetalles.table8[0],
                    ...ObjDetalles.table9[0],
                    ...ObjDetalles.table10[0]
                });

            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);



        }
        else {
            setCargando(true);
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };
    console.log(informe)


    return (
        <Container fluid className="bg-white rounded-3 shadow-sm p-3">
            {/* Encabezado mejorado */}
            <Row className="align-items-center mb-4">
                <Col xs={6} md={8}>
                    <div className="d-flex align-items-center">
                        <div>
                            <h5 className="fw-bold mb-0">Resumen de Facturación</h5>
                            <span className="text-muted small">Total consolidado del período</span>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={4}>
                    <div className="d-flex flex-column align-items-end">
                        <label htmlFor="date-picker" className="mb-1">Mes</label>
                        <DatePicker
                            selected={dateQuarter}
                            dateFormat="MMMM yyyy - QQQ"
                            className="form-control w-100"
                            showMonthYearPicker
                            onChange={handleDateChange}
                            id="date-picker"
                        />
                    </div>
                </Col>

            </Row>

            {cargando ? (
                <h5>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h5>
            ) : (
                <Row className="g-3">
                    {/* Sección INGRESO */}
                        <Col md={12}>
                            <div className="border rounded shadow-sm">
                                <h6 className="fw-bold p-2 bg-light border-bottom mb-0">FACTURAS EMITIDAS</h6>
                                <div className="p-2">
                                    {/* Primera fila con PUE y PPD */}
                                    <Row className="mb-3">
                                        {/* Columna PUE */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PUE - Pago en una exhibición - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between fw-bold small border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PUE")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PPD */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PPD - Pago parcialidades - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasEmitidas.find(f => f.vMetodoPago === "PPD")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Segunda fila con EGRESO y PAGO */}
                                    <Row>
                                        {/* Columna EGRESO */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PUE - PPD</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoEmitidas?.dTotalSubTotal || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoEmitidas?.dDescuento || 0, true)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoEmitidas?.dIva || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoEmitidas?.dIEPS || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total de impuestos trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoEmitidas?.dTotalImpuestosTrasladados || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {formatCurrency(egresoEmitidas?.dTotal || 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PAGO */}
                                        {/* Columna PAGO */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded h-100" style={{ display: "flex", flexDirection: "column" }}>
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">REP - RECIBO ELECTRÓNICO DE PAGO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 16:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoEmitidas?.dSubTotal16 || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 8:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoEmitidas?.dSubTotalBase8 || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 16:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoEmitidas?.dIva16 || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 8:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoEmitidas?.dIva8 || 0)}
                                                    </span>
                                                </div>

                                                {pagoEmitidas?.dIvaRetenido > 0 && (
                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">IVA Retenido:</span>
                                                        <span className="fw-semibold text-danger">
                                                            {formatCurrency(pagoEmitidas.dIvaRetenido, true)}
                                                        </span>
                                                    </div>
                                                )}

                                                {pagoEmitidas?.dIsrRetenido > 0 && (
                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">ISR Retenido:</span>
                                                        <span className="fw-semibold text-danger">
                                                            {formatCurrency(pagoEmitidas.dIsrRetenido, true)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Espaciador flexible que empuja el total hacia abajo */}
                                                <div className="flex-grow-1"></div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {formatCurrency(pagoEmitidas?.dTotal || 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>


                                </div>
                            </div>
                        </Col>


                        <Col md={12}>
                            <div className="border rounded shadow-sm mt-4">
                                <h6 className="fw-bold p-2 bg-light border-bottom mb-0">FACTURAS RECIBIDAS</h6>
                                <div className="p-2">
                                    {/* Primera fila con PUE y PPD */}
                                    <Row className="mb-3">
                                        {/* Columna PUE */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PUE - Pago en una exhibición - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between fw-bold small border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PPD */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">PPD - Pago parcialidades - INGRESO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalSubTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dDescuento || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIva || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIEPS || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIvaRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        <span className="fw-semibold">
                                                            {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIsrRetenido || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosTrasladados || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    <span className="fw-semibold">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosRetenidos || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotal || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {/* Columna EGRESO */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PUE - PPD</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoRecibidas?.dTotalSubTotal || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoRecibidas?.dDescuento || 0, true)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoRecibidas?.dIva || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoRecibidas?.dIEPS || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total de impuestos trasladados:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(egresoRecibidas?.dTotalImpuestosTrasladados || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {formatCurrency(egresoRecibidas?.dTotal || 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PAGO */}
                                        {/* Columna PAGO */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded h-100" style={{ display: "flex", flexDirection: "column" }}>
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">REP - RECIBO ELECTRÓNICO DE PAGO</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 16:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoRecibidas?.dSubTotal16 || 0)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal Base 8:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoRecibidas?.dSubTotalBase8 || 0)}
                                                    </span>
                                                </div>

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 16:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoRecibidas?.dIva16 || 0)}
                                                    </span>
                                                </div>
                                                

                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">IVA 8:</span>
                                                    <span className="fw-semibold">
                                                        {formatCurrency(pagoRecibidas?.dIva8 || 0)}
                                                    </span>
                                                </div>

                                                {pagoRecibidas?.dIvaRetenido > 0 && (
                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">IVA Retenido:</span>
                                                        <span className="fw-semibold text-danger">
                                                            {formatCurrency(pagoRecibidas.dIvaRetenido, true)}
                                                        </span>
                                                    </div>
                                                )}

                                                {pagoRecibidas?.dIsrRetenido > 0 && (
                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">ISR Retenido:</span>
                                                        <span className="fw-semibold text-danger">
                                                            {formatCurrency(pagoRecibidas.dIsrRetenido, true)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Espaciador flexible que empuja el total hacia abajo */}
                                                <div className="flex-grow-1"></div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    <span className="text-dark">
                                                        {formatCurrency(pagoRecibidas?.dTotal || 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>


                    {/*<Col md={6}>*/}
                    {/*    <div className="border rounded shadow-sm h-100">*/}
                    {/*        <h6 className="fw-bold p-2 bg-light border-bottom mb-0">COMPROBANTES DE EGRESO (E)</h6>*/}
                    {/*        <div className="p-2">*/}
                    {/*            <div className="bg-white p-2 rounded">*/}
                    {/*                    <div className="d-flex justify-content-between small  fw-bold">*/}
                    {/*                    <span className="text-secondary">Subtotal:</span>*/}
                    {/*                    <span className="fw-semibold">*/}
                    {/*                        {formatCurrency(facturasRecibidas?.dTotalSubTotal || 0)}*/}
                    {/*                    </span>*/}
                    {/*                </div>*/}
                    {/*                    <div className="d-flex justify-content-between small  fw-bold  border-top pt-1">*/}
                    {/*                        <span className="text-secondary">Descuento:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dDescuento || 0, true)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    */}{/* Impuestos Trasladados desglosados */}
                    {/*                    <div className="mt-2">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IVA:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dIva || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IEPS:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dIEPS || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                                        
                    {/*                </div>*/}

                    {/*                    */}{/* Impuestos Retenidos desglosados */}
                    {/*                    <div className="mt-2">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">IVA RET:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dIvaRetenido || 0, true)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">ISR RET:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dIsrRetenido || 0, true)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                                       
                    {/*                </div>*/}
                    {/*                    <div className="d-flex justify-content-between small border-top pt-1  fw-bold">*/}
                    {/*                        <span className="text-secondary">Total Trasladados:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dTotalImpuestosTrasladados || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small border-top pt-1  fw-bold">*/}
                    {/*                        <span className="text-secondary">Total Retenidos:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasRecibidas?.dTotalImpuestosRetenidos || 0, true)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">*/}
                    {/*                    <span>Total:</span>*/}
                    {/*                    <span className="text-dark">*/}
                    {/*                        {formatCurrency(facturasRecibidas?.dTotal || 0)}*/}
                    {/*                    </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</Col>*/}



                    {/*<Col md={6}>*/}
                    {/*    <div className="border rounded shadow-sm h-100">*/}
                    {/*        <h6 className="fw-bold p-2 bg-light border-bottom mb-0">COMPROBANTES DE PAGO (P)</h6>*/}
                    {/*        <div className="p-2">*/}
                    {/*            {facturasPago ? (*/}
                    {/*                <div className="bg-white p-2 rounded">*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">Traslados Base IVA16:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasPago.dTotalTrasladosBaseIVA16 || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between small">*/}
                    {/*                        <span className="text-secondary">Traslados Impuesto IVA16:</span>*/}
                    {/*                        <span className="fw-semibold">*/}
                    {/*                            {formatCurrency(facturasPago.dTotalTrasladosImpuestoIVA16 || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">*/}
                    {/*                        <span>Total General:</span>*/}
                    {/*                        <span className="text-dark">*/}
                    {/*                            {formatCurrency(facturasPago.dSumaTotal || 0)}*/}
                    {/*                        </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            ) : (*/}
                    {/*                <div className="text-center small py-2 text-muted">Sin operaciones registradas</div>*/}
                    {/*            )}*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="border rounded shadow-sm">
                                    <h6 className="fw-bold p-2 bg-light border-bottom mb-0">RESUMEN FINANCIERO</h6>
                                    <div className="p-2">
                                        <Row>
                                            <Col md={6} className="pe-1">
                                                <div className="border p-2 bg-white rounded mb-3">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">INGRESOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Ingresos Acumulables:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.IngresosAcumulables || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total IVA Causado:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.TotalIvaCausado || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Ingresos Efectivamente Cobrados:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.IngresosEfectivamenteCobrados || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total IVA Efectivamente Cobrado:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.TotalIvaEfectivamenteCobrado || 0)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={6} className="ps-1">
                                                <div className="border p-2 bg-white rounded mb-3">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">GASTOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Gastos Efectuados:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.GastosEfectuados || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de IVA a Acreditar:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.TotalIvaAcreditar || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Gastos Efectivamente Pagados:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.GastosEfectivamentePagados || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">IVA Acreditable del Periodo:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.IvaAcreditablePeriodo || 0)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <div className="border p-2 bg-white rounded">
                                                    <small className="d-block fw-bold text-uppercase text-primary mb-2">TOTALES DE IMPUESTOS</small>

                                                    <div className="d-flex justify-content-between small fw-bold">
                                                        <span className="text-secondary">Total de IVA a Pagar:</span>
                                                        <span className="fw-semibold text-dark">
                                                            {formatCurrency(informe.TotalIvaPagar || 0)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de IVA Retenido:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.TotalIvaRetenido || 0, true)}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                        <span className="text-secondary">Total de ISR Retenido:</span>
                                                        <span className="fw-semibold">
                                                            {formatCurrency(informe.TotalISRRetenido || 0, true)}
                                                        </span>
                                                    </div>

                                                    
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                </Row>
            )}
        </Container>
    );
};


const ResumenMensualImpuestos = () => {
    return (
        <ContabilidadLayout
            title={<><FontAwesomeIcon icon={faChartLine} className="me-2" />Resumen de Impuestos</>}
        >
            <ResumenMensualImpuestosContent />
        </ContabilidadLayout>
    );
};

export default ResumenMensualImpuestos;